import { listToTree } from '_u/helper'

// 房源选择
export default {
    props: {
        // 过滤-园区id
        parkId: {
            type: [String, Number],
            default: '',
        },
        // 过滤-楼栋id
        floorId: {
            type: [String, Number],
            default: '',
        },
        // 过滤-楼层号
        floorNum: {
            type: [String, Number],
            default: '',
        },
        // 过滤-房间状态(多个逗号分隔)
        houseStatus: {
            type: String,
            default: '',
        },
        // 默认选中的房间(多个逗号分隔)
        defaultHouseIds: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            selectedHouse: [],
        }
    },
    methods: {
        normalizeHouseList(list = []) {
            var parks = {}, // 园区
                buildings = {}, // 楼栋
                floors = {}, // 楼层
                treeList = [],
                selectedHouse = []

            // 获取treeList
            list.forEach((v) => {
                var floorNum = v.floorId + '_' + v.floorNum, // 楼栋id_楼层编号
                    room = {
                        ...v,
                        id: v.id,
                        pid: floorNum,
                        title: v.houseNum,
                        _level: 4,
                        checked:
                            (this.defaultHouseIds + ',').indexOf(v.id) >= 0,
                        expand: true,
                        spread: true, // 展开到房间
                    }

                // 房间
                treeList.push(room)
                if (room.checked) selectedHouse.push(room)

                // 楼层
                if (!floors[floorNum]) {
                    floors[floorNum] = {
                        id: floorNum,
                        pid: v.floorId,
                        parkName: v.parkName,
                        floorName: v.floorName,
                        title: v.floorNum + '层',
                        _level: 3,
                        expand: true,
                    }
                    treeList.push(floors[floorNum])
                }
                // 园区
                if (!this.parkId && !parks[v.parkId]) {
                    parks[v.parkId] = {
                        id: v.parkId,
                        pid: '0',
                        parkName: v.parkName,
                        floorName: v.floorName,
                        title: v.parkName,
                        _level: 1,
                        expand: true,
                    }
                    treeList.push(parks[v.parkId])
                }
                // 楼栋
                if (!this.floorId && !buildings[v.floorId]) {
                    buildings[v.floorId] = {
                        id: v.floorId,
                        pid: v.parkId,
                        parkName: v.parkName,
                        floorName: v.floorName,
                        title: v.floorName,
                        _level: 2,
                        expand: true,
                    }
                    treeList.push(buildings[v.floorId])
                }
            })
            // 初始化已选中的房间
            if (this.defaultHouseIds.length) {
                this.selectedHouse = selectedHouse
            }

            treeList = listToTree(treeList, {
                id: 'id',
                pId: 'pid',
            })

            // 顶部标题
            if (treeList.length) {
                var first = treeList[0]
                // 限定园区
                if (first._level == '2') {
                    this.title = `（${first.parkName}）`
                } else if (first._level == '3') {
                    // 限定楼栋
                    this.title = `（${first.parkName + first.floorName}）`
                } else {
                    this.title = ''
                }
            }

            return treeList
        },
        onCheckHouse(checkedList) {
            this.selectedHouse = checkedList.filter((v) => v._level == 4)
        },
    },
}
